import React from "react";

const AppML_Lists = () => {
  return (
    <div className="tutorial-page">
      <h1>AppML Lists</h1>
      <p>This is the AppML Lists page content.</p>
    </div>
  );
};

export default AppML_Lists;
